module.exports = __webpack_public_path__ + "8af0b95c806290e8f61a7ab7d5e34717.jpg";